import React from 'react';
import aditionalInformationModel from '../../models/aditionalInformationModel';
import ExternalReferralPage from '../erPage/ExternalReferralPage';

const AdditionalInformation = (props) => {
  let model = aditionalInformationModel();

  return (
    <ExternalReferralPage model={model} dataPropertyName="aditionalInformation" setBusy={props.setBusy} >
    </ExternalReferralPage>
  );
};

export default AdditionalInformation;
